import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { DrawerNavbar, LayoutDrawer } from "../../../components";
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";

import NewUserLocation from "../../../components/Icons/NewUserLocation";
import NewUserMail from "../../../components/Icons/NewUserMail";
import NewUserPhone from "../../../components/Icons/NewUserPhone";
import { PAGES_PATH } from "../../../navigation/params";
// import { paletteColors } from "../../../styles/muiTheme";
// import { useDrawer } from "../../../context/DrawerContext";
import { useGTM } from "../../../hooks/useGTM";
import { useModal } from "../../../context/ModalContext";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";

const MsaChangeContainer = () => {
  // const { closeDrawer, openDrawer } = useDrawer();
  const { closeModal } = useModal();
  const { user } = useUserStore();
  const [updateHospital, setUpdateHospital] = useState(false);
  const theme = useTheme();
  const mobileSize = useMediaQuery(theme.breakpoints.down("sm"));
  const [contactApplication, setContactApplication] = useState<string>("");
  const { dispatchEvent } = useGTM();
  const navigate = useNavigate();

  const handleCancel = () => {
    closeModal();
  };

  const handleNavigateToUpdateHospital = () => {
    navigate(`${PAGES_PATH.USER_PROFILE}/${PAGES_PATH.CHANGE_HOSPITAL}`);
  };

  useEffect(() => {
    if (localStorage.getItem("isWebUser") !== "undefined") {
      const isWebUser = JSON.parse(localStorage.getItem("isWebUser") || "{}");

      if (isWebUser?.nextScreen === "updateLocation") {
        setUpdateHospital(true);
        dispatchEvent({
          eventName: "book_visit_change_clinic",
        });
      } else if (isWebUser?.nextScreen === "differentMetro") {
        setUpdateHospital(false);
        dispatchEvent({
          eventName: "book_visit_change_msa",
        });
      }
    }
  }, []);

  useEffect(() => {
    if (user?.location?.phoneNumber) {
      const isAppleDevice = /iPad|iPhone|iPod|Mac/.test(navigator.userAgent);
      const contactMethod = isAppleDevice ? `facetime:${user.location.phoneNumber}` : `tel:${user.location.phoneNumber}`;

      setContactApplication(contactMethod);
    }
  }, [user]);


  return <LayoutDrawer
    drawerNavbar={mobileSize ? (
      <DrawerNavbar onBack={handleCancel} text={"Making a Change?"} ifIconClose={true}>
        <Box sx={{ display: "flex", width: "100%" }}>
        </Box>
      </DrawerNavbar>
    ) :
      <DrawerNavbar onBack={handleCancel} sx={{ pb: 0.5 }} text={"Making a Change?"} ifIconClose={true}>
        <Box sx={{ display: "flex", width: "100%" }}>
        </Box>
      </DrawerNavbar>
    }
    style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}
  >

    {updateHospital ? <>
      <div className="flex flex-col h-full justify-between overflow-y-auto">
        <div className="py-5">
          <h3 className="text-center font-semibold">It looks like you’re booking at a</h3>
          <h3 className="text-center font-semibold">new GoodVets hospital.</h3>
          <h3 className="text-center font-normal">
            Click “Update My Hospital” below to update your hospital and book your next visit.
          </h3>
        </div>


        <div className="flex justify-center">
          <img src="/assets/icons/newUser2.png" alt="new user image" className="w-72 2xl:w-4/5" />
        </div>

        <Button
          className="w-full mt-1 !normal-case !font-bold !sticky !bottom-2"
          id="goToUpdateHospital"
          type="button"
          onClick={handleNavigateToUpdateHospital}
        >
          Update My Hospital
        </Button>
      </div>
    </> :
      <div className="w-full flex flex-col overflow-y-auto max-h-[30rem] scroll-hide">
        <div className="flex flex-col gap-3 flex-grow pe-2">
          <h3 className="text-center font-semibold">
            It looks like you’re booking at a new GoodVets hospital, and in a new city to boot.
          </h3>
          <div>
            <h3 className="text-center font-normal">
              Please contact your GoodVets hospital to request transfer of your records to
            </h3>
            <h3 className="text-center font-normal">the new hospital.</h3>
          </div>

          <div className="p-6 flex flex-col items-center gap-6 rounded-lg bg-white">
            <h4 className="self-start font-semibold">{user?.location?.locationName}</h4>

            <div className="flex gap-5 w-full items-center">
              <NewUserPhone />
              <h3 className="text-primary">
                <a href={contactApplication}>{user?.location?.phoneNumber}</a>
              </h3>
            </div>

            <div className="flex gap-5 w-full items-center">
              <NewUserLocation />
              <h3>{user?.location?.address}</h3>
            </div>

            <div className="flex gap-5 w-full items-center">
              <NewUserMail />
              <h3>{user?.location?.email}</h3>
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          <img src="/assets/icons/newUser2.png" alt="new user image" className="w-72" />
        </div>
      </div>
    }

  </LayoutDrawer>;
};

export default MsaChangeContainer;
